<template>
	<HomeLayout>
		<saima :key="$i18n.locale+':a'" v="a"></saima>
	</HomeLayout>
</template>

<script>
	import saima from './saima.vue'
	import HomeLayout from '@/layout/HomeLayout.vue'
	import mixin from '@/utils/mixin';

	export default {
		mixins: [mixin],
		components: {
			HomeLayout,
			saima,
		},
		data() {
			return {

			}
		},
		mounted() {




		},
		methods: {



		}
	}
</script>

<style scoped>

</style>